import { useAppDispatch, useAppSelector } from "hooks";
import React, { useEffect } from "react";
import { simFlowFetchData, simFlowFetchSimRequestData } from "../../../../redux/simFlow/simFlowSlice";
import CommonLoader from "components/CommonLoader";

type PostOrderChangeResponseToNSOProps = {
  id: any;
};

// eslint-disable-next-line sonarjs/cognitive-complexity
function PostOrderChangeResponseToNSO({ id }: PostOrderChangeResponseToNSOProps) {
  // eslint-disable-next-line sonarjs/no-duplicate-string
  const simSelectorData = useAppSelector((state) => state.simFlow.simFlow.data[2].data);
  const [simSelector, setSimSelector] = React.useState<any>(simSelectorData);

  const simError = useAppSelector((state) => state.errorStep.simError);
  const isError = simError ? simError.step >= 10 : false;
  const isAlreadyFetched =
    simSelectorData instanceof Array
      ? false
      : "status" in simSelectorData
        ? true
        : simSelectorData.flow_dtl_id === Number(id);

  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!isError && !isAlreadyFetched) {
      dispatch(simFlowFetchData());
      dispatch(simFlowFetchSimRequestData({ id, stepId: 10 }));
    } else {
      setSimSelector(simSelectorData);
    }
  }, [dispatch, id, isAlreadyFetched, isError, simSelectorData]);
  const simSelectorLoading = useAppSelector((state) => state.simFlow.simFlow.loading);
  // const filteredIlaFactory = simSelector.response_json?.accessoryDetail?.filter((item: any) => item.accessoryType === "F");
  // const filteredIlaPPo = simSelector.response_json?.accessoryDetail?.filter((item: any) => item.accessoryType === "P");
  const vehicleIdentifierData: Array<any> = [
    {
      id: 1,
      name: "Region Code",
      value: simSelector.request_json?.currentRegionCode ?? "",
    },
    {
      id: 2,
      name: "Model Code",
      value: simSelector.request_json?.modelCode ?? "",
    },
    {
      id: 3,
      name: "Model Year",
      value: simSelector.request_json?.modelYear ?? "",
    },
    {
      id: 4,
      name: "Model Cost Phase",
      value: simSelector.request_json?.modelCostPhase ?? "",
    },
    {
      id: 5,
      name: "Model Price Phase",
      value: simSelector.request_json?.modelPricePhase ?? "",
    },
    {
      id: 6,
      name: "Global Plant Source Code",
      value: simSelector.request_json?.globalPlantSourceCode ?? "",
    },
    {
      id: 7,
      name: "Ship to Dealer Code",
      value: simSelector.request_json?.shipToDealerCode ?? "",
    },
    {
      id: 8,
      name: "Ship to Region Code",
      value: simSelector.request_json?.shipToRegionCode ?? "",
    },
    {
      id: 9,
      name: "Fleet Indicator",
      value: simSelector.request_json?.fleetIndicator ? "Yes" : "No",
    },
    {
      id: 10,
      name: "Unpriced Indicator",
      value: simSelector.response_json?.unpricedIndicator ? "Yes" : "No",
    },
  ];
  const factoryAccessoryPriceData: Array<any> = [
    {
      id: 1,
      name: "DAPCAP",
      value: simSelector.response_json?.totalFio?.factoryAccessoryDAPCAP ?? "",
    },
    {
      id: 2,
      name: "Dealer Cost",
      value: simSelector.response_json?.totalFio?.factoryAccessoryDealerCost ?? "",
    },
    {
      id: 3,
      name: "Distributor Cost",
      value: simSelector.response_json?.totalFio?.factoryAccessoryDistributorCost ?? "",
    },
    {
      id: 4,
      name: "Holdback",
      value: simSelector.response_json?.totalFio?.factoryAccessoryHoldback ?? "",
    },
    {
      id: 5,
      name: "Wholesale Financial Reserve",
      value: simSelector.response_json?.totalFio?.factoryAccessoryWholesaleFinancialReserve ?? "",
    },
    {
      id: 6,
      name: "Suggessted FIO Retail Amount",
      value: simSelector.response_json?.totalFio?.suggestedFIORetailAmount ?? "",
    },
    {
      id: 7,
      name: "Total TMS Cost",
      value: simSelector.response_json?.totalFio?.totalFactoryAccessoryTMSCost ?? "",
    },
  ];

  const portInstallOptionData: Array<any> = [
    {
      id: 1,
      name: "Dealer Cost",
      value: simSelector.response_json?.totalPio?.portInstalledOptionDealerCost ?? "",
    },
    {
      id: 2,
      name: "Distributor Cost",
      value: simSelector.response_json?.totalPio?.portInstalledOptionDistributorCost ?? "",
    },
    {
      id: 3,
      name: "Holdback",
      value: simSelector.response_json?.totalPio?.portInstalledOptionHoldback ?? "",
    },
    {
      id: 4,
      name: "Suggested PPO Retail Amount",
      value: simSelector.response_json?.totalPio?.suggestedPPORetailAmount ?? "",
    },
  ];
  const modelData: Array<any> = [
    {
      id: 1,
      name: "Dealer Base Price",
      value: simSelector.response_json?.model?.dealerBasePrice ?? "",
    },
    {
      id: 2,
      name: "Distributor Base Price Amount",
      value: simSelector.response_json?.model?.distributorBasePriceAmount ?? "",
    },
    {
      id: 3,
      name: "Retail Base Price",
      value: simSelector.response_json?.model?.retailBasePrice ?? "",
    },
    {
      id: 4,
      name: "TMS Base Cost Amount",
      value: simSelector.response_json?.model?.tmsBaseCostAmount ?? "",
    },
  ];

  const miscelleneousData: Array<any> = [
    {
      id: 1,
      name: "Holdback",
      value: simSelector.response_json?.model?.modelHoldback ?? "",
    },
    {
      id: 2,
      name: "DAPCAP",
      value: simSelector.response_json?.model?.modelDAPCAP ?? "",
    },
    {
      id: 3,
      name: "Cost Phase",
      value: simSelector.response_json?.modelCostPhase ?? "",
    },
    {
      id: 4,
      name: "Price Phase",
      value: simSelector.response_json?.modelPricePhase ?? "",
    },
  ];

  // const vehicleAccessoryData: Array<any> = responseData?.vehicleAccessory?.forEach((item: any, index: number) => {
  //   return {
  //     id: index,
  //     name: item.accessoryCode,
  //     value: item.accessoryPricePhase,
  //   };
  // });
  const generateVehicleAccessoryData = () => {
    const vehicleAccessoryData: Array<any> = [];
    simSelector.response_json?.vehicleAccessories.forEach((item: any, index: number) => {
      vehicleAccessoryData.push({
        id: index,
        name: "Accessory Code",
        value: item.accessoryCode,
      });
      vehicleAccessoryData.push({
        id: index,
        name: "Accessory Price Phase",
        value: item.accessoryPricePhase,
      });
    });
    return vehicleAccessoryData;
  };
  const vehicleAccessoryData = generateVehicleAccessoryData();

  const renderData: Array<any> = [
    {
      id: 1,
      title: "Vehicle Identifier",
      data: vehicleIdentifierData,
    },
    {
      id: 2,
      title: "Factory Accessory Price",
      data: factoryAccessoryPriceData,
    },
    {
      id: 3,
      title: "Port Install Options",
      data: portInstallOptionData,
    },
    {
      id: 4,
      title: "Model",
      data: modelData,
    },
    {
      id: 5,
      title: "Miscellaneous",
      data: miscelleneousData,
    },
    {
      id: 6,
      title: "Vehicle Accessories",
      data: vehicleAccessoryData,
    },
  ];
  // console.log("renderData", RequestedConfiguration[4]);

  if (simSelectorLoading) {
    return <CommonLoader active={simSelectorLoading} />;
  }
  return (
    <>
      <div className="border border-gray-300 rounded-lg shadow-lg gap-4">
        {renderData.map((item) => {
          return (
            <div className="w-full bg-gray-100 rounded-lg py-2 m-2" key={item.id}>
              <div className="flex w-full justify-start items-center content-center">
                <span className="font-bold mx-4 text-xl">{item.title}</span>
              </div>
              <div className="border border-gray-300 rounded-lg my-2 mx-0"></div>
              {item.title === "Vehicle Accessories" ? (
                <div className="grid grid-cols-2 m-4 gap-4">
                  {item.data.map((items: any) => (
                    <div className="" key={items.id}>
                      <div className="bg-yellow grid grid-cols-2 m-2 gap-4">
                        <div className="text-base">{items.name}</div>
                        <div className="text-base">{items.value}</div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="grid grid-cols-3 m-4 gap-4">
                  {item.data.map((items: any) => (
                    <div className="" key={items.id}>
                      <div className="bg-yellow grid grid-cols-2 m-2 gap-4">
                        <div className="text-base">{items.name}</div>
                        <div className="text-base">{items.value}</div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </>
  );
}

export default PostOrderChangeResponseToNSO;
